module.exports = "img/grinwall-logo.485bed.png";